import styled from 'styled-components';
import { centerMessage } from 'styles/helpers/utils';

const GetProfileWrapper = styled.div`
  height: 100%;

  .message {
    ${centerMessage};
  }
`;

export { GetProfileWrapper };
